/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductsNoResults extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      aggs_applied:
        Object.keys(props.applied_aggregates).length > 0 &&
        props.applied_aggregates.constructor === Object,
      message: this.formatErrorMessage(props)
    };
  }

  formatErrorMessage(props) {
    switch (props.mode) {
      case 'brand':
        return (
          <div>
            Sorry, we couldn't find any matching products from the brand
            specified.
          </div>
        );
      case 'category':
        return (
          <div>
            Sorry, we couldn't find any matching products from the category
            specified.
          </div>
        );
      default:
        return (
          <div>
            Sorry, we couldn't find any search results matching{' '}
            <span>'{this.props.query}'</span>
          </div>
        );
    }
  }

  render() {
    const {
      resetAllAggregates,
      assets,
      b2bPhoneNumber,
      customerServicesEmail
    } = this.props;

    let reset_aggs =
      this.state.aggs_applied === true ? (
        <span className="no-filters">
          Filters have been applied.
          <button onClick={resetAllAggregates} className="btn">
            <img src={assets.icons.search_white} alt="" />
            Try your search without filters
          </button>
        </span>
      ) : (
        ''
      );
    return (
      <div className="products-no-results">
        <div className="row-fluid">
          <div className="span12">
            <h1>
              {this.state.message}
              {reset_aggs}
            </h1>
            <hr />
          </div>
        </div>
        <div className="row-fluid">
          <div className="span5">
            <p className="search-tip-notice">
              Please refine your search or alternatively contact our customer
              service team.
            </p>
            <h4>Search Tips</h4>
            <ul className="search-tips">
              <li>Try using fewer key words</li>
              <li>Check for spelling errors</li>
              <li>Browse using our categories menu</li>
              <li>Search by Part Code or Stock Code</li>
            </ul>
          </div>
          <div className="span7">
            <ul className="no-results-list">
              <li>
                <img src={assets.icons.phone_red} className="icon" alt="" />
                You can also call <strong>{b2bPhoneNumber}</strong> to talk to
                an advisor.
                <br />
                Lines are open from 8am-8pm Monday-Friday.
              </li>
              <li>
                <img src={assets.icons.chat_red} className="icon" alt="" />
                For immediate assistance please use our online chat.
                <br />
                Open from 8am-8pm Monday-Friday.
              </li>
              <li>
                <img src={assets.icons.marker_red} className="icon" alt="" />
                If you would like to talk to someone in person.
                <br />
                User our friendly branch finder.
              </li>
              <li>
                <img src={assets.icons.email_red} className="icon" alt="" />
                We are also contactable by email if your enquiry is out
                <br />
                of hours at{' '}
                <a href={`mailto:${customerServicesEmail}`}>
                  <strong>{customerServicesEmail}</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductsNoResults;
